module.exports = {"labels":{"name":"Nome","cpf":"CPF","dob":"Data do seu nascimento","gender":"Sexo","maritalStatus":"Estado civil","mothersName":"Nome da sua mãe","emiteNotaFiscal":"Desejo enviar meus dados pessoais para os parceiros conveniamos me identificarem na emissão de Nota Fiscal Eletrônica.","pap":"Desejo aderir ao Ponto-a-Ponto"},"errorMessages":{"emptyField":"Campo obrigatório"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/EditUserDataForm/data.json
// module id = 1688
// module chunks = 0